'use client';

import { useMemo } from 'react';
import type { Card, FormInstance } from '../types';

/**
 * Hook to manage card instance logic
 */
export const useCardInstances = (card: Card, completedForms: Record<string, FormInstance[]>) => {
  return useMemo(() => {
    const instances = completedForms[card.groupKey] || [];
    const canAddMore = card.maxInstances ? instances.length < card.maxInstances : false;
    const hasData = instances.length > 0;
    const showCTA = card.showCTA !== false; // Default to true if not specified

    return {
      instances,
      canAddMore,
      hasData,
      showCTA,
    };
  }, [card, completedForms]);
};
